import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var userDataExon = localStorage.getItem("userDataExon") ? JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon")))) : "";

var serviceName = "index";
var projeService = {
    imageUrlBuyuk: WsProvider.resim + "/" + userDataExon["firmaKodu"] + "/buyuk/",
    imageUrlOrta: WsProvider.resim + "/" + userDataExon["firmaKodu"] + "/orta/",
    imageUrlKucuk: WsProvider.resim + "/" + userDataExon["firmaKodu"] + "/kucuk/",
    imageUrlEnKucuk: WsProvider.resim + "/" + userDataExon["firmaKodu"] + "/enkucuk/",
    path  : "https://www.exonbiyotek.com/",
    projeTanimlama(link, pkategoriId, baslik, altBaslik, icerik, resimList, resimKonum, menuKonum, galeriKonum, url, baslamaTarihi, bitisTarihi, sayac, begen, seoBaslik, seoIcerik,dil) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                pkategoriId: pkategoriId,
                link: link,
                baslik: baslik,
                altBaslik: altBaslik,
                icerik: icerik,
                resimList: resimList,
                resimKonum: resimKonum,
                menuKonum: menuKonum,
                galeriKonum: galeriKonum,
                url: url,
                baslamaTarihi: baslamaTarihi,
                bitisTarihi: bitisTarihi,
                sayac: sayac,
                begen: begen,
                seoBaslik: seoBaslik,
                seoIcerik: seoIcerik,
                dil: dil,
                serviceName: "proje",
                methodName: "projeTanimlama"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    projeDetay(projeId) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                projeId: projeId,
                dil: "",
                serviceName: "proje",
                methodName: "projeDetay"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },


    projeListesi(durum,baslangic,limit) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                durum: durum,
                dil: [],
                baslangic: baslangic,
                limit: limit,
                serviceName: "proje",
                methodName: "projeListesi"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    projeDurumGuncelle(projeId, durum) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                projeId: projeId,
                durum: durum,
                serviceName: "proje",
                methodName: "projeDurumGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    projeGuncelle(projeId, updateList) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                projeId: projeId,
                updateList: updateList,
                serviceName: "proje",
                methodName: "projeGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

}

export default projeService

